/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-17 15:15:12
 * @modify date 2023-11-17 15:15:12
 * @desc [description]
 */

import { ListTableHeader } from "components/base/table/listTableType";
import i18n from "lang/base";
import { FONT } from "value/staticValues";



export interface BackupShareExternalData {
  real_size_mb: number;
  vm_backup_filename: string;
}


export interface BackupShareInternalData {
  backup_image_file_exists_yn: boolean;
  real_size_mb: number;
  vm_backup_description: string;
  vm_backup_filename: string;
  vm_backup_id: string;
  vm_backup_name: string;
}


export interface BackupShareData {
  external_vm_backup_files:  BackupShareExternalData[];
  internal_vm_backups:  BackupShareInternalData[];
}


export const initBackupShareData = {
  external_vm_backup_files: [{
    real_size_mb: 0,
    vm_backup_filename: "",
  }],
  internal_vm_backups: [{
    backup_image_file_exists_yn: false,
    real_size_mb: 0,
    vm_backup_description: "",
    vm_backup_filename: "",
    vm_backup_id: "",
    vm_backup_name: "",
  }]
}


export const internalTableHeader:ListTableHeader[] = [
  {
    Header: i18n.t("VM_BACKUP_IMAGE_NAME"),
    accessor: "vm_backup_name",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value || "-"}</div>)
  },
  {
    Header: i18n.t("VM_BACKUP_IMAGE_DESC"),
    accessor: "vm_backup_description",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value || "-"}</div>)
  },
  {
    Header: i18n.t("VM_BACKUP_IMAGE_FILE_NAME"),
    accessor: "vm_backup_filename",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value || "-"}</div>)
  },
  {
    Header: i18n.t("VM_BACKUP_REAL_SIZE_MB"),
    accessor: "real_size_mb",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value || "0"}{'MB'}</div>)
  },
]


export const externalTableHeader:ListTableHeader[] = [
  {
    Header: i18n.t("VM_BACKUP_IMAGE_FILE_NAME"),
    accessor: "vm_backup_filename",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value || "-"}</div>)
  },
  {
    Header: i18n.t("VM_BACKUP_REAL_SIZE_MB"),
    accessor: "real_size_mb",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value || "0"}{'MB'}</div>)
  },
]


const className = {
  statusContainer: {
      width: 56,
      display: "flex", Jusitipy: "center", justifyContent: "center",
      borderRadius: 10,
      backgroundColor: "#b6bfce",
      fontFamily: FONT.REGULAR,
      fontSize: 12,
      color: "#fff"
  },
  normalTextContainer: {
      fontFamily: FONT.REGULAR,
      fontSize: 12,
      color: "#333",
      overflow: "hidden"
  },
  dateContainer: {
      color: "#9ea0a5",
  },
  resourceContainer: {
      color: "#0853fb"
  },
  statusImg: {
      marginRight: 3
  },
  resourceImg: {
      width: 24,
      height: 24
  },
  usageContainer: {
      paddingLeft: 20
  },
  usageRowContainer: {
      width: "120px",
      display: "flex",
      alignItems: "center"
  },
  usageImg: {
      width: "24px",
      height: "24px",
      filter: "opacity(0.5)"
  },
  usageText: {
      fontFamily: FONT.REGULAR,
      fontSize: "10px",
      color: "#8793a3"
  },
  usageStorageValue: {
      marginLeft: "auto",
      marginRight: "5px",
      fontFamily: FONT.MEDIUM,
      fontSize: "12px",
      color: "#5a7ee9"
  },
  usageWarnValue: {
      marginLeft: "auto",
      marginRight: "5px",
      fontFamily: FONT.MEDIUM,
      fontSize: "12px",
      color: "#e6735c"
  },
  warnImg: {
      width: 20,
      height: 20
  },
  osdBox: {
      width: 20,
      height: 20,
      borderRadius: 2,
      backgroundColor: "#5a7ee9",
      display: "flex",
      alignItems: "center",
      justifyContents: "center"
  }
}